const STORAGE_KEY = "guest_tablet_device_token";

/** Persistenter Geräte-Token (wird bei Freischaltung serverseitig zugeordnet). */
export function getOrCreateGuestTabletDeviceToken(): string {
  try {
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing && existing.length >= 16) {
      return existing;
    }
  } catch {
    // localStorage nicht verfügbar (privater Modus o. Ä.)
  }
  const token = `${crypto.randomUUID().replace(/-/g, "")}${crypto.randomUUID().replace(/-/g, "").slice(0, 8)}`;
  try {
    localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Token nur für diese Sitzung nutzbar
  }
  return token;
}
